import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import lockr from 'lockr';
import { fetchApi } from '../fetchApi';

const { REACT_APP_API_URL } = process.env;

const initialState = {
  isloggedIn: !!lockr.get('APP_AUTH_KEY'),
};

const newPasswordCustomer = createAsyncThunk(
  'authorization/forgotPasswordCustomer',
  async (body) => {
    const header = { 'Content-type': 'application/json' };
    return await fetchApi(
      `${REACT_APP_API_URL}/customers/update-password`,
      'POST',
      header,
      JSON.stringify(body),
    );
  },
);

const twoFactorSetup = createAsyncThunk(
  'authorization/forgotPasswordCustomer',
  async (body) => {
    const token = lockr.get('APP_AUTH_KEY');
    const header = {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    return await fetchApi(
      `${REACT_APP_API_URL}/auth/2fa/setup`,
      'POST',
      header,
      JSON.stringify(body),
    );
  },
);

const twoFactorSetupVerify = createAsyncThunk(
  'authorization/forgotPasswordCustomer',
  async (body) => {
    const token = lockr.get('APP_AUTH_KEY');
    const header = {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    return await fetchApi(
      `${REACT_APP_API_URL}/auth/2fa/setup/verify`,
      'POST',
      header,
      JSON.stringify(body),
    );
  },
);

const twoFactorSignInVerify = createAsyncThunk(
  'authorization/forgotPasswordCustomer',
  async (body) => {
    const token = lockr.get('APP_AUTH_KEY');
    const header = {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    return await fetchApi(
      `${REACT_APP_API_URL}/auth/2fa/verify`,
      'POST',
      header,
      JSON.stringify(body),
    );
  },
);

const fetchScienceSamples = createAsyncThunk(
  'authorization/forgotPasswordCustomer',
  async (body) => {
    const header = { 'Content-type': 'application/json' };
    return await fetchApi(
      `${REACT_APP_API_URL}/support/request_science_samples_beta`,
      'POST',
      header,
      JSON.stringify(body),
    );
  },
);

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    login: (state, { payload: token }) => {
      lockr.set('APP_AUTH_KEY', token);
      state.APP_AUTH_KEY = token;
      state.isloggedIn = true;
    },
    logout: (state) => {
      state.isloggedIn = false;
      state.APP_AUTH_KEY = null;

      localStorage.removeItem('APP_AUTH_KEY');
      localStorage.removeItem('access_token');
      localStorage.removeItem('cart_id');
    },
  },
});

export const actions = {
  ...authorizationSlice.actions,
  newPasswordCustomer,
  twoFactorSetup,
  twoFactorSetupVerify,
  twoFactorSignInVerify,
  fetchScienceSamples,
};

export default authorizationSlice.reducer;
